module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/partnerUI/partner-dashboard/partner-dashboard.component.scss
// module id = ./src/app/partnerUI/partner-dashboard/partner-dashboard.component.scss
// module chunks = main